import { AnalyticCategories, AnalyticService } from '@application/analytic/analytic.service';
import { BreakPoints, Spacer, useBreakpoint } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { AnalyticProvider } from '@components/analytic_link/analytic_link.provider';
import { FlexibleIdentifier } from '@components/flexible_identifier/flexible_identifier.component';
import { SuspendedPresentation } from '@components/suspended_presentation.component';
import { withTranslation } from '@modules/i18n_and_l10n/with_translation';
import { useTitle } from '@src/application/use_title';
import { useService } from '@visiba/instantiation';
import { useEffect } from 'react';
import { ReceptionHomeController } from './_reception_home.controller';
import { ReceptionHomeAboutUs } from './_reception_home_about_us.component';
import { ReceptionHomeHero } from './_reception_home_hero.component';
import { ReceptionHomeLayout } from './_reception_home_layout.component';
import { ReceptionHomeSkeleton } from './_reception_home_skeleton.component';
import { useDemandManagementStatus } from './use-demand-management-status';

interface Props {
	__TEMP__on_OPW_WebContentButton_proxy_invoke?: (flexibleIdentifierData: {
		url: string;
		openUrlWith: string;
		requiresAuthentication: boolean;
	}) => void;
}

export function ReceptionHome({ __TEMP__on_OPW_WebContentButton_proxy_invoke }: Props): JSX.Element {
	// biome-ignore lint/correctness/noUnusedVariables: suppressed due to migration - should be fixed
	const breakpoint = useBreakpoint();
	const controller = useService(ReceptionHomeController);
	const analyticService = useService(AnalyticService);
	const accessFlow = useDemandManagementStatus();

	useTitle(withTranslation('PW.Page.ReceptionHome.Title'));

	useEffect(
		function analyticQuirk_whenComponentMounts() {
			analyticService.trackPageView({ customTitle: 'Reception Home' });
		},
		[analyticService],
	);

	useEffect(
		function whenComponentMounts() {
			controller.onMount();
		},
		[controller],
	);

	return (
		<AnalyticProvider category={AnalyticCategories.ReceptionHome}>
			<SuspendedPresentation controller={controller} fallback={<ReceptionHomeSkeleton />}>
				{({ components, textAboutUs }) => {
					const buttonIdentifierList = components.map((component) => (
						<FlexibleIdentifier
							key={component.id}
							component={component}
							__TEMP__on_OPW_WebContentButton_proxy_invoke={__TEMP__on_OPW_WebContentButton_proxy_invoke}
							accessFlow={accessFlow}
						/>
					));

					return (
						<ReceptionHomeLayout
							data-testid='reception_home'
							actionSection={buttonIdentifierList}
							heroSection={<ReceptionHomeHero controller={controller} />}
							aboutUsSection={textAboutUs != null ? <ReceptionHomeAboutUs textAboutUs={textAboutUs} /> : null}
							footerSection={<></>}
						></ReceptionHomeLayout>
					);
				}}
			</SuspendedPresentation>
		</AnalyticProvider>
	);
}
